/*
  Mobile drawer categories (MS-008, Menu page).

  The theme drives every .Dropdown on the site through one Dropdown class with a global
  lock: while any panel animates, taps are ignored; opening one closes the others; and its
  height:auto clean-up can fire after a close and pop the section back open. In the drawer
  this script takes the category buttons over (capture phase, before the theme's delegate
  on body) and leaves every other dropdown on the site to the theme.

  - Sections open independently; tapping one never moves another.
  - Open 300ms, close 240ms, on the house curve cubic-bezier(.4,0,.2,1).
  - Always from the height the panel has right now, so a tap mid-animation reverses it.
  - A pending clean-up is cancelled the moment the other direction starts.
  - Reduced motion: no travel, straight to the end state.
*/
(function () {
  var OPEN = 300, CLOSE = 240, CURVE = 'cubic-bezier(.4, 0, .2, 1)';
  var drawer = document.getElementById('Drawer');
  if (!drawer) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function settle(panel, open) {
    if (panel._onEnd) panel.removeEventListener('transitionend', panel._onEnd);
    panel._onEnd = null;
    panel.style.transition = '';
    panel.style.height = '';
    panel.style.visibility = '';
    if (!open) panel.setAttribute('aria-hidden', 'true');
  }

  function toggle(button) {
    var panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    var open = button.getAttribute('aria-expanded') !== 'true';
    var from = panel.getBoundingClientRect().height;

    if (panel._onEnd) panel.removeEventListener('transitionend', panel._onEnd);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', 'false');

    panel.style.transition = 'none';
    panel.style.visibility = 'visible';
    panel.style.height = 'auto';
    var to = open ? panel.getBoundingClientRect().height : 0;

    if (reduced.matches || from === to) { settle(panel, open); return; }

    panel.style.height = from + 'px';
    panel.getBoundingClientRect();
    panel.style.transition = 'height ' + (open ? OPEN : CLOSE) + 'ms ' + CURVE;
    panel.style.height = to + 'px';
    panel._onEnd = function (e) {
      if (e.target === panel && e.propertyName === 'height') settle(panel, open);
    };
    panel.addEventListener('transitionend', panel._onEnd);
  }

  // Tablet: the dimmed page beside the 375px drawer is the drawer's ::after, so a tap on it
  // lands on the drawer itself, to the right of its box. Close the menu like the X does.
  drawer.addEventListener('click', function (e) {
    if (e.target !== drawer || e.clientX < drawer.getBoundingClientRect().right) return;
    var close = document.querySelector('[data-action="toggle-drawer"][data-toggle-id="Drawer"]');
    if (close) close.click();
  });

  drawer.addEventListener('click', function (e) {
    var button = e.target.closest('.mobile-menu__section > .DropdownInnerWrapper > .Dropdown--Button');
    if (!button || !drawer.contains(button)) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(button);
  }, true);
})();

/*
  Mobile menu 2026: tabs and tap tracking.

  Tabs (Indoor / Outdoor) follow the WAI-ARIA tab pattern: click or Enter selects, Left/Right
  move between tabs, the panel that is not selected is [hidden].

  Tracking: every tap on a [data-track] element in the drawer is published as the Shopify
  custom event "bycrea_menu_tap", and every opening of the drawer as "bycrea_menu_open", so
  taps can be read per open and compared with the menu this replaces. Custom pixels receive
  them with analytics.subscribe('bycrea_menu_tap', ...); consent stays the pixel's job.
  menu_version marks which menu produced the event.
*/
(function () {
  var drawer = document.getElementById('Drawer');
  var root = drawer && drawer.querySelector('[data-mm26]');
  if (!root) return;
  var VERSION = 'mobile-2026';

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* tracking must never break the menu */ }
  }

  // Promo videos: no download until the drawer opens; play only while the drawer is open and
  // the video's tab is showing; the pause button wins until pressed again. Reduced motion
  // starts paused (the poster stays).
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var videos = Array.prototype.slice.call(root.querySelectorAll('[data-mm26-video]'));
  videos.forEach(function (v) { v._userPaused = reducedMotion; });
  function syncVideos() {
    var open = isOpen;
    videos.forEach(function (v) {
      var panel = v.closest('[data-mm26-panel]');
      var show = open && panel && !panel.hidden;
      var btn = v.parentNode.querySelector('[data-mm26-pause]');
      if (btn) {
        btn.setAttribute('aria-pressed', v._userPaused ? 'true' : 'false');
        btn.setAttribute('aria-label', v._userPaused ? btn.getAttribute('data-label-play') : btn.getAttribute('data-label-pause'));
      }
      if (show && !v._userPaused) {
        if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-mm26-video'));
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    });
  }
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mm26-pause]');
    if (!btn) return;
    var v = btn.parentNode.querySelector('[data-mm26-video]');
    if (!v) return;
    v._userPaused = !v._userPaused;
    syncVideos();
  });

  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mm26-tab]'));
  function activeTab() {
    var t = root.querySelector('[data-mm26-tab][aria-selected="true"]');
    return t ? t.getAttribute('data-track-label') : '';
  }
  function select(tab, focus) {
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    if (focus) tab.focus();
    syncVideos();
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { select(t); });
    t.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      select(next, true);
    });
  });

  root.addEventListener('click', function (e) {
    var el = e.target.closest('[data-track]');
    if (!el || !root.contains(el)) return;
    publish('bycrea_menu_tap', {
      menu_version: VERSION,
      element: el.getAttribute('data-track'),
      label: el.getAttribute('data-track-label') || '',
      position: Number(el.getAttribute('data-track-pos')) || 0,
      tab: el.getAttribute('data-track') === 'tab' ? el.getAttribute('data-track-label') : activeTab(),
      href: el.getAttribute('href') || '',
      path: location.pathname
    });
  });

  // The theme opens in two steps (aria-hidden="false" at once, aria-expanded="true" one frame
  // later) and closes with aria-expanded="false" first, aria-hidden="true" after the slide.
  // Open = the first opening signal, closed = the first closing one.
  var isOpen = drawer.getAttribute('aria-expanded') === 'true';
  new MutationObserver(function (records) {
    var was = isOpen;
    records.forEach(function (r) {
      var val = drawer.getAttribute(r.attributeName);
      if (r.attributeName === 'aria-hidden') { if (val === 'false') isOpen = true; else if (val === 'true') isOpen = false; }
      if (r.attributeName === 'aria-expanded') isOpen = val === 'true';
    });
    if (isOpen && !was) publish('bycrea_menu_open', { menu_version: VERSION, tab: activeTab(), path: location.pathname });
    if (isOpen !== was) syncVideos();
  }).observe(drawer, { attributes: true, attributeFilter: ['aria-expanded', 'aria-hidden'] });
})();
